

const eanCD =  (barcode) =>
    {
      var cd = 0
      for (var i = 0; i < 11 ; i++)
      {  
        cd = cd + parseInt(barcode.substr(i,1))
        cd = cd + parseInt(barcode.substr(i + 1, 1)) * 3
        /* step2 */
        i++
      }
      cd = (10 - cd % 10) % 10
      return cd
    }


const  createEAN13  = (productId,counter)  =>
    { 
      const codifica = '3000000'
      const pad      = '00000'
      
      var barcode    = codifica.substring(0,7-productId.toString().length) + productId.toString()
      barcode        += pad.substring(0,5-counter.toString().length) + counter.toString()
      const cd       = eanCD(barcode)
      return barcode + cd

    }


export default { createEAN13, eanCD };